<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/POA/components/Budget/components/Available'

    export default {
        components: {
            Grid,
        }
    }
</script>